import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { IShelf } from "interface/showcase";
import showcaseService from 'services/showcase';

export interface IState {
  shelves: IShelf[];
  loading: boolean;
  update: boolean;
}

const initialState: IState = {
  shelves: null,
  loading: false,
  update: false,
};

export const fetchShelves = createAsyncThunk(
  'showcase/fetch', () => showcaseService.getShowcase()
);

const showcase = createSlice({
  name: 'showcase',
  initialState,
  reducers: {
    updateShelves: (state) => {
      state.update = true;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchShelves.pending, (state) => {
      state.loading = true;
      state.shelves = null;
      state.update = false;
    }).addCase(fetchShelves.fulfilled, (state, action) => {
      state.shelves = action.payload;
      state.loading = false;
    }).addCase(fetchShelves.rejected, (state) => {
      state.shelves = [];
      state.loading = false;
    });
  },
});

export const { updateShelves } = showcase.actions;
export default showcase.reducer;
